export default {
  ActionTypes: {
    ACCEPT_EXCHANGE_BID: 'ACCEPT_EXCHANGE_BID',
    ACCEPT_TOS: 'ACCEPT_TOS',
    APPROVE_PUNCHES: 'APPROVE_PUNCHES',
    BID_ON_DROPPED_SHIFT: 'BID_ON_DROPPED_SHIFT',
    BID_ON_EXCHANGE: 'BID_ON_EXCHANGE',
    CANCEL_EXCHANGE: 'CANCEL_EXCHANGE',
    CANCEL_REQUEST_OFFER: 'CANCEL_REQUEST_OFFER',
    CANCEL_TIMEOFF_REQUEST: 'CANCEL_TIMEOFF_REQUEST',
    CHECK_TOKEN_EXPIRATION: 'CHECK_TOKEN_EXPIRATION',
    CHANGE_EVENT: 'change',
    CLEAR_CALENDAR: 'CLEAR_CALENDAR',
    CONFIRM_ACTION : 'CONFIRM_ACTION',
    CORE_SHOW_USER: 'SHOW_CORE_USER',
    CREATE_AVAILABLE: 'CREATE_AVAILABLE',
    CREATE_EXCHANGE: 'CREATE_EXCHANGE',
    CREATE_SHIFT: 'CREATE_SHIFT',
    CREATE_UNAVAILABLE: 'CREATE_UNAVAILABLE',
    DELETE_AVAILABLE: 'DELETE_AVAILABLE',
    DELETE_RECURING_AVAILABLE: 'DELETE_RECURING_AVAILABLE',
    DELETE_BIDS: 'DELETE_BIDS',
    DELETE_SHIFT: 'DELETE_SHIFT',
    GET_ALL_EXCHANGES: 'GET_ALL_EXCHANGES',
    GET_ALL_SHIFTS: 'GET_ALL_SHIFTS',
    GET_AVAILABLES: 'GET_AVAILABLES',
    GET_DEPARTMENT: 'GET_DEPARTMENT',
    GET_DEPARTMENT_SCHEDULE: 'GET_DEPARTMENT_SCHEDULE',
    GET_EXCHANGES: 'GET_EXCHANGES',
    GET_LOCATION: 'GET_LOCATION',
    GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
    GET_SETTINGS: 'GET_SETTINGS',
    GET_SHARED_CALENDAR: 'GET_SHARED_CALENDAR',
    GET_SHIFTS: 'GET_SHIFTS',
    GET_SHIFT_BY_ID: 'GET_SHIFT_BY_ID',
    GET_SHIFT_BY_DATE: 'GET_SHIFT_BY_DATE',
    GET_TIMESHEETS: 'GET_TIMESHEETS',
    GET_UNAVAILABLES: 'GET_UNAVAILABLES',
    GET_UNAVAILABLE_TYPES: 'GET_UNAVAILABLE_TYPES',
    GET_USER: 'GET_USER',
    LOOKUP_WORKSPACE: 'LOOKUP_WORKSPACE',
    MARK_NOTIFICATION_AS_READ: 'MARK_NOTIFICATION_AS_READ',
    MARK_ALL_NOTIFICATIONS_AS_READ: 'MARK_ALL_NOTIFICATIONS_AS_READ',
    PASSWORD_VALIDITY: 'PASSWORD_VALIDITY',
    POST_LOGIN: 'POST_LOGIN',
    PUBLISH_RANGE: 'PUBLISH_RANGE',
    REFRESH_UNAVAILABLES: 'REFRESH_UNAVAILABLES',
    REQUEST_OFFER: 'REQUEST_OFFER',
    REQUEST_OFFER_WITH_CONFLICT: 'REQUEST_OFFER_WITH_CONFLICT',
    UPDATE_PASSWORD: 'UPDATE_PASSWORD',
    UPDATE_SETTINGS: 'UPDATE_SETTINGS',
    UPDATE_SHIFT: 'UPDATE_SHIFT',
    UPDATE_USER: 'UPDATE_USER',
    USER_CHANGED: 'USER_CHANGED',
    REMOVE_SHARED_CALENDAR: 'REMOVE_SHARED_CALENDAR',
    REQUEST_PASSWORD: 'REQUEST_PASSWORD',
    SEND_SHARED_CALENDAR: 'SEND_SHARED_CALENDAR',
    SETTINGS_CHANGED: 'SETTINGS_CHANGED',
  },

  ApiPaths: {
    API_VERSION_PATH: '/api/v3/',
    API_VERSION_5_PATH: '/api/v5/',
    MAKESHIFT_BASE_URL_DEV: window.EmployeeWeb.ENVConfig.ms_host,
    WORKSPACE_REGISTRY_BASE_URL: window.EmployeeWeb.ENVConfig.workspace_registry_url,
  },

  EndPoints: {
    ADVERTISEMENTS_POST_PATH: 'shifts/%d/exchanges',
    ADVERTISEMENTS_EXCHANGE_PATH: 'exchanges',
    AVAILABILITIES_PATH: 'availabilities', // API_VERSION_5_PATH
    BIDS_ACCEPT_PATH: 'exchanges/%d/accept',
    BIDS_CREATE_PATH: 'exchanges/%d/bids',
    BIDS_DELETE_PATH: 'exchanges/%d/bids/destroy_all',
    DELETE_AVAILABILITIES_PATH: 'availabilities/%d',
    DEPARTMENTS_SCHEDULE_PATH: 'departments/%d/schedule',
    GET_DEPARTMENTS: 'departments/%d',
    GET_LOCATIONS: 'locations/%d',
    GET_SETTINGS: 'user_setting',
    GET_USER: 'users/%d',
    LOGIN_PATH: 'auth/sign_in',
    LOGOUT_PATH: 'auth/sign_out',
    NOTIFICATIONS_PATH: 'notifications',
    NOTIFICATIONS_MARK_AS_READ: 'notifications/%d/mark_as_read',
    NOTIFICATIONS_MARK_ALL_AS_READ: 'notifications/mark_all_as_read',
    OFFER_REPLIES_CREATE_PATH: 'offers/%d/offer_replies',
    OFFER_REPLIES_DELETE_PATH: 'offer_replies/%d',
    PASSWORD_RESET_PATH: 'password',
    PASSWORD_VALIDITY: 'password_complexity',
    RECURING_AVAILABILITY: 'recurring_availabilities',
    SCHEDULE_SHARES_PATH: 'schedule_shares',
    SHIFTS_PATH: 'shifts',
    TIMESHEETS: 'timesheets',
    TIMESHEET_APPROVAL: 'punches/approvals',
    TIME_CLOCK_PATH: 'punches',
    TOKEN_PATH: 'auth/token',
    UNAVAILABLES_PATH: 'unavailables',
    UNAVAILABLE_TYPES_PATH: 'unavailable_types',
    UNAVAILABLE_REQUESTS_PATH: 'unavailable_requests',
    UPDATE: 'users/%d/settings',
    UPDATE_PASSWORD: 'users/update_password',
    UPDATE_SETTINGS: 'user_setting',
    UPDATE_USER: 'user',
    USER_PROFILE_PATH: 'user',
    WORKSPACES_PATH: 'workspaces',
  },

  EndPointParameterKeys: {
    APP_VERSION_PARAM: 'app_version',
    AVAILABLE_SHIFT_ID: 'available_shift_id',
    BID_ID_PARAM: 'bid_id',
    CURRENT_PASSWORD_PARAM: 'current_password',
    DATE_PARAM: 'date',
    DEPARMENT_ID_PARAM: 'department_id',
    DEVICE_ID_PARAM: 'device_uuid',
    DEVICE_TOKEN_STRING_PARAM: 'device_token',
    DEVICE_TYPE_PARAM: 'device_type',
    DROP_PARAM: 'drop',
    EMAIL_PARAM: 'email',
    ENDS_AT_PARAM: 'ends_at',
    END_DATE_PARAM: 'end_date',
    END_PARAM: 'end',
    EXCHANGE_ID_PARAM: 'exchange_id',
    GRANT_TYPE_PARAM: 'grant_type',
    LOCALE: 'locale',
    LOCATION_ID_PARAM: 'location_id',
    NOTES_PARAM: 'notes',
    OS_VERSION_PARAM: 'os_version',
    PASSWORD_CONFIRM_PARAM: 'password_confirmation',
    PASSWORD_PARAM: 'password',
    PHONE_NUMBER_PARAM: 'phone_number',
    PUSH_SETTINGS_PARAM: 'user_setting',
    PUNCH_IDS: 'punch_ids',
    RESET_PASSWORD_TOKEN_PARAM: 'reset_password_token',
    SCHEDULE_SHARE_ID_PARAM: 'id',
    SHIFT_ID_PARAM: 'shift_id',
    RECURRING_AVAILABILITY_EXCEPT: 'except',
    RECURRING_AVAILABILITY_ID: 'id',
    SHIFT_IDS_PARAM: 'shift_ids',
    SKIP_DELIVERY: 'skip_delivery',
    STARTS_AT_PARAM: 'starts_at',
    START_DATE_PARAM: 'start_date',
    START_PARAM: 'start',
    TIMEOFF_REQUEST_ID: 'unavailable_request_id',
    UNAVAILABLE_PARTIAL_PARAM: 'partial',
    UNAVAILABLE_TYPE_ID_PARAM: 'unavailable_type_id',
    USER_ID_PARAM: 'user_id',
    USER_PARAM: 'user',
    USERNAME_PARAM: 'email',
    USERNAME_ID_PARAM: 'username',
    WORKSPACE_ID_PARAM: 'workspace_id',
  },

  SSOMethods: {
    ADP: 'adp',
    BAMBOO: 'bamboo',
    COGNITO: 'cognito',
    E_DAYS: 'edays',
  }
};
